<template>
  <div class="columns is-gapless">
    <div class="column">
      <datepicker
      :inputClass="'input'"
      :format="'yyyy-MM-dd'"
      @reset="clear"
      v-model="dateRangeMin"
      :clear-button="true"
      :clear-button-icon="'fa fa-times'"
      v-on:input="$emit('update:dateMin', getDate(dateRangeMin)); $emit('change');"
      />
    </div> -
    <div class="column">
      <datepicker
      :inputClass="'input'"
      :format="'yyyy-MM-dd'"
      @reset="clear"
      v-model="dateRangeMax"
      :clear-button="true"
      :clear-button-icon="'fa fa-times'"
      v-on:input="$emit('update:dateMax', getDate(dateRangeMax)); $emit('change');"
      />
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'dateRangeFilter',
  props: ['dateMin', 'dateMax', 'reset'],
  components: {Datepicker},
  data () {
    return {
      dateRangeMin: this.dateMin,
      dateRangeMax: this.dateMax
    }
  },
  methods: {
    clear () {
      this.dateRangeMin = null
      this.dateRangeMax = null
    },
    getDate (value) {
      return value ? value.toISOString().substring(0, 10) : null
    }
  },
  watch: {
    dateMax () {
      this.dateRangeMax = this.dateMax
    },
    dateMin () {
      this.dateRangeMin = this.dateMin
    }
  }
}
</script>
<style lang="scss" scoped>
.columns{
  align-items: center;
}
.vdp-datepicker{
  margin:1px;
}
</style>


// WEBPACK FOOTER //
// src/components/DateRangeFilter.vue